import { useSearchParams } from 'react-router-dom';

type AuthUserType = 'partner' | 'portfolio' | 'investor';

const useAuthNavigator = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const userType = searchParams.get('userType') as AuthUserType;

  const handleUserType = (userType: AuthUserType) => () => {
    searchParams.set('userType', userType);
    setSearchParams(searchParams);
  };

  return {
    userType,
    handleUserType,
  };
};

export default useAuthNavigator;
